import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';

const ReportTimeIcon = (props: SvgProps) => <Svg
  width={20}
  height={20}
  viewBox='0 0 18 18'
  fill='none'
>
  <Path
    d='M8.99935 0.527344C4.40435 0.527344 0.666016 4.26568 0.666016 8.86068C0.666016 13.4557 4.40435 17.194 8.99935 17.194C13.5943 17.194 17.3327 13.4557 17.3327 8.86068C17.3327 4.26568 13.5943 0.527344 8.99935 0.527344ZM8.99935 15.5273C5.32352 15.5273 2.33268 12.5365 2.33268 8.86068C2.33268 5.18484 5.32352 2.19401 8.99935 2.19401C12.6752 2.19401 15.666 5.18484 15.666 8.86068C15.666 12.5365 12.6752 15.5273 8.99935 15.5273Z'
    fill={props.color ?? '#4A535A'}
  />
  <Path
    d='M9.83268 4.69336H8.16602V9.69336H13.166V8.02669H9.83268V4.69336Z'
    fill={props.color ?? '#4A535A'}
  />
</Svg>;

export default ReportTimeIcon;
